<template>
  <!-- <header ref="header" 
          class="fixed w-full z-[100] transition-all duration-300"
          :class="[scrolled ? 'py-2 bg-[#1E2652]/90 backdrop-blur-sm' : 'py-4', 
                  atTop ? 'bg-transparent' : 'bg-[#1E2652]/90 backdrop-blur-sm']"> -->
  <header ref="header" 
          class="fixed w-full z-[100] transition-all duration-300"
          :class="[scrolled ? 'py-4 bg-[#1E2652]/70 backdrop-blur-sm' : 'py-4', 
                  atTop ? 'py-4 bg-[#1E2652]/90 backdrop-blur-sm' : 'bg-[#1E2652]/70 backdrop-blur-sm']">
    <nav class="container mx-auto px-6 relative">
      <div class="flex items-center justify-between">
        <!-- Logo -->
        <div class="flex items-center w-1/3">
          <router-link to="/" class="flex items-center">
            <img src="@/assets/logo-without-text.png" alt="PadelGo Logo" class="w-10 h-10 mr-3" />
            <div class="text-3xl flex items-center">
              <span class="text-white font-light">Padel</span>
              <span class="text-[#B7E000] font-semibold">Go</span>
            </div>
          </router-link>
        </div>
        
        <!-- Desktop Navigation -->
        <div class="hidden lg:flex items-center justify-center w-1/3">
          <div class="flex items-center space-x-12">
            <template v-for="item in navItems" :key="item.to">
              <router-link :to="item.to" 
                class="nav-link relative text-white/90 hover:text-white transition-all duration-300 py-2"
                :class="{ 'active': isActive(item.to) }">
                <span class="text-lg font-light tracking-wider transition-all duration-300"
                      :class="{ 'text-xl text-[#B7E000] font-medium': isActive(item.to) }">
                  {{ item.text }}
                </span>
                <span class="nav-line" :class="{ 'w-full': isActive(item.to) }"></span>
              </router-link>
            </template>
          </div>
        </div>

        <!-- CTA Button -->
        <div class="hidden lg:flex w-1/3 justify-end">
          <a href="https://manager.padelgo.ma" 
             target="_blank" 
             rel="noopener noreferrer"
             class="bg-[#B7E000] text-[#1E2652] font-semibold px-8 py-3 rounded-full hover:opacity-90 transition-all duration-300 text-base">
            Espace club
          </a>
        </div>
        <!-- <div class="hidden lg:block">
          <router-link to="/download" class="btn-primary">
            Vous êtes un club ?
          </router-link>
        </div> -->

        <!-- Mobile Menu Button -->
        <button @click="toggleMobileMenu" 
                class="lg:hidden relative w-14 h-14 text-white focus:outline-none"
                aria-label="Toggle mobile menu"
                :aria-expanded="mobileMenuOpen">
          <div class="menu-icon" :class="{ 'menu-icon--active': mobileMenuOpen }">
            <div class="menu-icon__line"></div>
            <div class="menu-icon__line"></div>
          </div>
        </button>
      </div>
    </nav>
  </header>

  <!-- Mobile Modal via Teleport -->
  <teleport to="body">
    <div v-if="mobileMenuOpen" class="lg:hidden fixed inset-0 z-[101]">
      <!-- Backdrop with click handler to close modal -->
      <div class="absolute inset-0 bg-[#1E2652]/90 backdrop-blur-sm transition-opacity duration-300 opacity-100" 
           @click="toggleMobileMenu"></div>
      <!-- Modal Content (stops propagation so clicks here don't close modal) -->
      <div @click="toggleMobileMenu" 
           class="fixed inset-0 flex items-center justify-center transition-opacity duration-300 opacity-100">
        <!-- Close button -->
        <button @click.stop="toggleMobileMenu" 
                class="absolute top-6 right-6 text-white hover:text-[#B7E000] transition-colors duration-300"
                aria-label="Close menu">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <ul @click.stop class="flex flex-col items-center space-y-8 p-8 w-11/12 max-w-sm">
          <li v-for="item in navItems" :key="item.to">
            <router-link :to="item.to"
              class="text-white text-xl font-light tracking-wider hover:text-[#B7E000] transition-colors duration-300"
              :class="{ 'text-[#B7E000]': isActive(item.to) }"
              @click="toggleMobileMenu">
              {{ item.text }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';

const header = ref<HTMLElement | null>(null);
const scrolled = ref(false);
const atTop = ref(true);
const mobileMenuOpen = ref(false);
const route = useRoute();

const navItems = [
  { to: '/#features', text: 'Fonctionnalités' },
  { to: '/#partenaires', text: 'Partenaires' },
  // { to: '/about', text: 'À propos' },
  // { to: '/#how-it-works', text: 'Comment ça marche' },
  // { to: '/#pricing', text: 'Tarifs' },
  { to: '/contact', text: 'Contact' },
  { to: '/conditions', text: 'Conditions' },
];

const isActive = (path: string) => {
  if (path.startsWith('/#')) {
    return route.path === '/' && route.hash === path.substring(1);
  }
  return route.path === path;
};

const handleScroll = () => {
  const scrollPosition = window.scrollY;
  scrolled.value = scrollPosition > 50;
  atTop.value = scrollPosition <= 10;
};

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value;
  document.body.style.overflow = mobileMenuOpen.value ? 'hidden' : '';
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  handleScroll();
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped>
.btn-primary {
  @apply bg-[#B7E000] text-[#1E2652] font-semibold px-6 py-3 rounded-full hover:opacity-90 transition-all duration-300;
}
.nav-line {
  @apply absolute bottom-0 left-1/2 w-0 h-0.5 bg-[#B7E000] transition-all duration-300 -translate-x-1/2;
}
.nav-link:hover .nav-line {
  @apply w-full;
}
.nav-link.active .nav-line {
  @apply w-full;
}
.menu-icon {
  @apply relative w-8 h-8;
}
.menu-icon__line {
  @apply absolute left-0 w-8 h-0.5 bg-white transition-all duration-300;
}
.menu-icon__line:first-child {
  @apply top-1/2 -translate-y-2;
}
.menu-icon__line:last-child {
  @apply top-1/2 translate-y-1;
}
.menu-icon--active .menu-icon__line:first-child {
  @apply rotate-45 translate-y-0;
}
.menu-icon--active .menu-icon__line:last-child {
  @apply -rotate-45 translate-y-0;
}
</style>
